import { CommonModule, DatePipe } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { EnlargeQrCodeComponent } from '@app/components/enlarge-qr-code/enlarge-qr-code.component';
import { ShareqrcodeComponent } from '@app/components/share-qr-code/share-qr-code.component';
import { ViewEntitlementComponent } from '@app/components/view-ush-entitlement/view-entitlement.component';
import { FormFieldsModule } from '@upr-web-primer/form-fields';
import { InheritStyleModule } from '@upr-web-primer/inherit-style';
import { LocaleModule } from '@upr-web-primer/locale';
import { ModalModule } from '@upr-web-primer/modal';
import { MsUtilsModule } from '@upr-web-primer/ms-utils';
import { UprSvgModule } from '@upr-web-primer/svg';
import { TooltipModule } from '@upr-web-primer/tooltip';
import { UrlInfoModule } from '@upr-web-primer/url-info';
import { WindowModule } from '@upr-web-primer/window';
import { SharedModule } from '../../shared/shared-module';
import { EntitlementRoutingModule } from './entitlement.routing.module';
import { QRCodeComponent } from 'angularx-qrcode';
@NgModule({
  imports: [
    CommonModule,
    WindowModule,
    LocaleModule,
    UrlInfoModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    TooltipModule,
    FormsModule,
    MsUtilsModule,
    FormFieldsModule,
    InheritStyleModule,
    UprSvgModule,
    SharedModule,
    EntitlementRoutingModule,
    QRCodeComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  declarations: [
    ViewEntitlementComponent,
    EnlargeQrCodeComponent,
    ShareqrcodeComponent,
  ],
  providers: [Title, DatePipe],
})
export class EntitlementModule {}
